import { Icon, IconName } from '@openeducation/oe-rn-components';
import React from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { IconButton, TouchableRipple } from 'react-native-paper';

import styles from './navbar-icon-button.style';
import { useColors } from '../../hooks';
import { ThemedText } from '../themed-text';

interface NavbarIconButtonProps {
  icon: IconName;
  title?: string;
  size?: number;
  iconSize?: number;
  onPress?: () => void;
  active?: boolean;
  iconButtonStyle?: StyleProp<ViewStyle>;
  titlePlacement?: 'top' | 'right' | 'bottom' | 'left';
  disabled?: boolean;
}

export function NavbarIconButton({
  icon,
  title,
  size = 24,
  iconSize,
  onPress,
  active = false,
  iconButtonStyle,
  titlePlacement = 'bottom',
  disabled = false,
}: NavbarIconButtonProps) {
  const colors = useColors();

  if (!icon) {
    return null;
  }

  const RenderIcon = () => (
    <Icon
      name={icon}
      size={iconSize || size - 2}
      type={active ? 'solid' : 'light'}
      color={
        disabled ? colors.darkGray : active ? colors.primary : colors.grayDark
      }
    />
  );

  const getPlacementStyles = (): any => {
    switch (titlePlacement) {
      case 'top':
        return { flexDirection: 'column-reverse', paddingBottom: 2 };
      case 'right':
        return { flexDirection: 'row', paddingLeft: 8 };
      case 'bottom':
        return { flexDirection: 'column', paddingTop: 2 };
      case 'left':
        return { flexDirection: 'row-reverse', paddingRight: 8 };
    }
  };

  if (title) {
    const { flexDirection, ...textPading } = getPlacementStyles();

    return (
      <TouchableOpacity disabled={disabled}>
        <TouchableRipple
          disabled={disabled}
          style={[styles.titleButtonContainer, { flexDirection }]}
          onPress={onPress}
        >
          <>
            <RenderIcon />
            <ThemedText
              type={disabled ? 'darkGray' : active ? 'primary' : 'onBackground'}
              style={[styles.title, textPading]}
            >
              {title}
            </ThemedText>
          </>
        </TouchableRipple>
      </TouchableOpacity>
    );
  }

  return (
    <IconButton
      disabled={disabled}
      size={size}
      style={iconButtonStyle}
      icon={() => (
        <View style={styles.container}>
          <RenderIcon />
        </View>
      )}
      onPress={onPress}
    />
  );
}
